module.exports = __webpack_public_path__ + "img/features-1.bda743bd.jpg";